import { Controller } from "stimulus";
import axios from "axios";

export default class extends Controller {
  static targets = ["downloadButton", "destroyButton", "compareButton"];

  connect() {
    this.selectedIds = [];
    this.urls = [];
    this.jszip = null
    import("jszip").then(({default: JSZip}) => {
      this.jszip = JSZip
    })
  }

  readMode(){
    return JSON.parse(this.element.dataset.readMode)
  }

  toggleCheckbox(event) {
    event.target.checked
        ? this.selectedIds.push(event.target.value)
        : (this.selectedIds  = this.selectedIds.filter(
            id => id !== event.target.value
          ));
    const urlData = JSON.parse(event.target.dataset.url)
    event.target.checked
        ? this.urls.push(urlData)
        : (this.urls  = this.urls.filter(
            url => url.download !== urlData.download
          ));

    this.setCompareUrl()
    this.setDestroyUrl();

    if (this.selectedIds.length > 0) {
      this.downloadButtonTarget.removeAttribute("disabled")
    } else {
      this.downloadButtonTarget.setAttribute("disabled", "")
    }
  }

  setDestroyUrl() {
    if (this.selectedIds.length === 0) {
      this.destroyButtonTarget.setAttribute("href", "#");
      return;
    }

    this.selectedIds.length > 0
          ? this.destroyButtonTarget.removeAttribute("disabled")
          : this.destroyButtonTarget.setAttribute("disabled", "");

    if (this.readMode()) {
      return false;
    }

    this.destroyButtonTarget.dataset.confirmSweet =
      this.selectedIds.length === 1
        ? "Tem certeza que deseja apagar esse arquivo?"
        : `Tem certeza que deseja apagar ${this.selectedIds.length} arquivos?`;

    const url =
      this.destroyButtonTarget.dataset.url +
      "?" +
      this.selectedIds
        .map(id => encodeURI(`ids[]=${id}`))
        .join("&");

    this.destroyButtonTarget.setAttribute("href", url);
  }

  setCompareUrl() {
    if (this.selectedIds.length !== 2 ) {
      this.compareButtonTarget.setAttribute("href", "#");
      this.compareButtonTarget.setAttribute("disabled", "");
      return;
    }

    this.compareButtonTarget.removeAttribute("disabled")

    if (this.readMode()) {
      return false;
    }

    const url =
      this.compareButtonTarget.dataset.url +
      `?` +
      this.selectedIds
        .map(id => encodeURI(`ids[]=${id}`))
        .join("&");

    this.compareButtonTarget.setAttribute("href", url);
  }

  handleDownloadButton(){

    if (this.urls.length === 1) {
      downloadFiles(this.urls)
      return
    }

    this.downloadFilesAsZip(this.urls)
  }

  downloadFilesAsZip(urls) {
    this.updateDownloadButton("downloading")
    const JSZip = this.jszip

    const zip = new JSZip();
    const folder = zip.folder("imagens");

    Promise.all(urls.map(url =>
      axios(url.download, { responseType: 'arraybuffer'})
    )).then(responses => {
        responses.map((response, index) => {
          folder.file(urls[index].filename, response.data, { binary: true })
        })

        zip.generateAsync({ type:"blob" })
          .then((content) => {
            downloadBlob(content, `arquivos-paciente-${this.data.get('patient-filename')}.zip`);
            this.updateDownloadButton("success");
          });
      }).catch(error => {
        console.error(error)
        Bugsnag.notify(error)
        this.updateDownloadButton("error")
      })
  }

  updateDownloadButton(status){
    if (status === "downloading") {
      this.downloadButtonTarget.innerHTML = `<svg class="tw-inline tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg> Baixando imagens...`
      this.downloadButtonTarget.setAttribute("disabled", "")
    }

    if (status === "success") {
      this.downloadButtonTarget.innerHTML = `<svg class="tw-inline tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg> Baixar imagens`
      this.downloadButtonTarget.removeAttribute("disabled", "")
    }

    if (status === "error") {
      this.downloadButtonTarget.removeAttribute("disabled", "")
      toastr.error("Ocorreu um erro ao baixar os arquivos")
    }

  }
}


function downloadFiles(files) {
  function downloadNext(i) {
    if (i >= files.length) {
      return;
    }
    const a = document.createElement('a');
    a.href = files[i].download;
    a.target = '_parent';
    // Use a.download if available, it prevents plugins from opening.
    if ('download' in a) {
      a.download = files[i].filename;
    }
    // Add a to the doc for click to work.
    (document.body || document.documentElement).appendChild(a);
    if (a.click) {
      a.click(); // The click method is supported by most browsers.
    } else {
      $(a).click(); // Backup using jquery
    }
    // Delete the temporary link.
    a.parentNode.removeChild(a);
    downloadNext(i + 1);
  }
  downloadNext(0);
}

function downloadBlob(blob, name = 'file.txt') {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = name;
  document.body.appendChild(link);
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );
  document.body.removeChild(link);
}

